// authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getEvents } from "../../../services/users";

// Async Thunks for API calls
export const getAllEvents = createAsyncThunk(
  "get-dashboard-data-with-user-id",
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await getEvents(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: error.message || "something went wrong",
        },
      );
    }
  },
);

const eventSlice = createSlice({
  name: "events",
  // initialState: {
  //     events: [],
  // },

  initialState: {
    events: [],
    isLoading: false,
    error: null,
  },

  reducers: {
    setEvents(state, action) {
      state.events = action.payload;
    },
  },
  //   extraReducers: (builder) => {
  //     builder
  //       .addCase(getAllEvents.pending, (state) => {
  //         state.events = [];
  //       })
  //       .addCase(getAllEvents.fulfilled, (state, action) => {
  //         state.events = Array.isArray(action.payload?.resultData)
  //           ? action.payload.resultData
  //           : [];
  //       })
  //       .addCase(getAllEvents.rejected, (state, action) => {
  //         state.events = [];
  //       });
  //   },

  extraReducers: (builder) => {
    builder
      .addCase(getAllEvents.pending, (state) => {
        state.isLoading = true;
        state.error = null;

        // Existing events ko blank nahi karna.
      })

      .addCase(getAllEvents.fulfilled, (state, action) => {
        state.isLoading = false;

        const receivedEvents = Array.isArray(action.payload?.resultData)
          ? action.payload.resultData
          : [];

        // Sirf valid non-empty response se list update hogi.
        if (receivedEvents.length > 0) {
          state.events = receivedEvents;
        }
      })

      .addCase(getAllEvents.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || "Unable to load events";

        // Failure par previous valid events screen par rahenge.
      });
  },
});

export const { setEvents } = eventSlice.actions;

export default eventSlice.reducer;
